import { render, staticRenderFns } from "./PepperNews.vue?vue&type=template&id=4152fe6b&"
import script from "./PepperNews.vue?vue&type=script&lang=js&"
export * from "./PepperNews.vue?vue&type=script&lang=js&"
import style0 from "./PepperNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports